import Vue from 'vue'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import '@/assets/scss/date-time-picker.scss'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker)